import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {extractProps} from 'utils/propUtils';


const propTypes = {
  className: PropTypes.string,
};

export default function UndoIcon({className, ...otherProps}) {
  return <FontAwesomeIcon icon={['far', 'arrow-rotate-left']} className={className} {...extractProps(otherProps)} />;
}
UndoIcon.propTypes = propTypes;
